import { render, staticRenderFns } from "./custom-tag-select.vue?vue&type=template&id=defe57cc&scoped=true"
import script from "./custom-tag-select.vue?vue&type=script&lang=js"
export * from "./custom-tag-select.vue?vue&type=script&lang=js"
import style0 from "./custom-tag-select.vue?vue&type=style&index=0&id=defe57cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defe57cc",
  null
  
)

export default component.exports